export const ELEMENT_PREFIX = 'filter-by-direction-of-effect';
export const ODDS_RATIO_FILTER_LABEL = 'Odds Ratio < 1';
export const EFFECT_SIZE_FILTER_LABEL = 'Effect Size < 0';
export const EFFECT_SIZE_TOOLTIP_TEXT = 'Filter associations to those with effect size < 0';
export const ODDS_RATIO_TOOLTIP_TEXT = 'Filter associations to those with odds ratio < 1';
